
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import * as service from '../../../../services/service';

function AddEditVendor() {
    const [state, setState] = useState({ vendorname: '', address: '', contactperson: '', contactno: '', pan: '', gstno: '' });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const params = useParams();
    const getDetailsById = () => {
        setLoading(true);
        const errs = {};
        if (params.id > 0) {
            fetch(
                service.GET_VENDOR_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        VendorId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({ ...state, vendorname: result.vendorName, address: result.address, contactperson: result.contactPerson,
                                        contactno: result.contactNo, pan: result.pan, gstno: result.gstNo });
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }

                });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (params.id > 0) {
            getDetailsById();
        }
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!state.vendorname) {
            isValid = false;
            errs[".vendorname"] = "Please enter vendor name";
        }
        setErrors(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_VENDOR,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        VendorId: params.id ? params.id : null,
                        VendorName: state.vendorname,  
                        Address: state.address,
                        ContactPerson: state.contactperson,
                        ContactNo: state.contactno,
                        PAN: state.pan,
                        GSTNo: state.gstno,    
                        ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,                             
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,                  
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/masters/vendor');
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/masters/vendor');
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });        
            }
            setLoading(false);
        }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <MDBox pt={4} pb={3} px={3} style={{ width: '50%' }}>
                                    <MDBox component="form" role="form">
                                        <MDBox mb={2}>
                                            <MDInput label="Vendor Name" fullWidth value={state.vendorname || ''}
                                                name="vendorname"
                                                onChange={changeHandler}
                                                id="vendorname"
                                                required />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".vendorname"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="Address" fullWidth value={state.address || ''}
                                                name="address"
                                                onChange={changeHandler}
                                                id="address"
                                                 />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".address"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="Contact Person" fullWidth value={state.contactperson || ''}
                                                name="contactperson"
                                                onChange={changeHandler}
                                                id="contactperson"
                                                 />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".contactperson"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="Contact No." fullWidth value={state.contactno || ''}
                                                name="contactno"
                                                onChange={changeHandler}
                                                id="contactno"
                                                 />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".contactno"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="PAN" fullWidth value={state.pan || ''}
                                                name="pan"
                                                onChange={changeHandler}
                                                id="pan"
                                                 />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".pan"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="GST No." fullWidth value={state.gstno || ''}
                                                name="gstno"
                                                onChange={changeHandler}
                                                id="gstno"
                                                 />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".gstno"]}</div>
                                        </MDBox>
                                        <MDBox mt={4} mb={1} textAlign="center">
                                            {loading ? <Oval
                                                heigth="20"
                                                width="20"
                                                color='grey'
                                                ariaLabel='loading'
                                            /> :
                                                <MDButton color="info" onClick={submitHandler}>
                                                    SAVE
                                                </MDButton>
                                            }
                                            {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddEditVendor;